import React from 'react';
interface CTAButtonProps {
  text: string;
  variant?: 'primary' | 'white';
}
export const CTAButton = ({
  text,
  variant = 'primary'
}: CTAButtonProps) => {
  const baseClasses = 'px-6 py-3 rounded-full font-bold text-center transition-all duration-300 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 inline-block';
  const variantClasses = {
    primary: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
    white: 'bg-white hover:bg-gray-100 text-red-600 focus:ring-red-500'
  };
  return <button className={`${baseClasses} ${variantClasses[variant]}`} data-id="element-48">
      {text}
    </button>;
};